import type { FaireProductEntity } from "../../entity_types/product";

export const p_2sttmv6gqe: FaireProductEntity = {
  token: "p_2sttmv6gqe",
  type: "product",
  name: "Sunkist Grape - KOREA (15 COUNT)",
  brandToken: "b_pdahr8yenn",
  brandName: "Exotic Snacks Wholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/dda046eba77bda8b8a22f8f1c0625cfdf6bda82a1ef42ed19f9d072630985b59.jpeg",
  galleryImageUrls: [],
  priceDollars: 41.57,
  description:
    "Enjoy the zesty and refreshing flavor of Sunkist Lemon & Lime. Each pack includes 15 bottles of lemon and lime-flavored soda.\n\nMSRP: $5.99\n",
  tags: [],
  msrpDollars: 83.14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:31.811Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
